module.exports = __webpack_public_path__ + "static/img/luxiangjilu2.9f65c8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/luxiangjilu2.png
// module id = rvD9
// module chunks = 24